import React from "react";
import { imageBaseUrl } from "../constants/ApiConstants";
import { format4DigitTimeToAmOrPM, getAgeFromGivenDate } from "../utils/utils";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { tuftsBlue } from "../constants/colors";

const PatientAppointmentRequestCard = ({ image, name, gender, dateOfBirth, appointmentDate, appointmentTime, showView, showViewHref, showAppointmentTimeAndDate = true }) => {
  function formatDate(inputDate) {
    const date = new Date(inputDate);
    const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear();
    const dayName = days[date.getDay()];
    return `${day} ${month}, ${year} : ${dayName}`;
  }

  return (
    <Wrapper className="bg-grey2 rounded appointment__item py-2 col-md-6 mx-2">
      <div className="appointment__item-img">
        {image == null ? (
          <div className="bg-info-surface name__placeholder">
            <span>{name?.charAt(0)}</span>
          </div>
        ) : (
          <img src={`${imageBaseUrl}/${image}`} alt="Profile" />
        )}
      </div>
      <div className="content d-flex flex-column gap-1">
        <strong className="text-dark mt-2">{name}</strong>
        <span className="d-block text-grey2 fs-sm">{`${getAgeFromGivenDate(dateOfBirth)} Years: ${gender === 1 ? "Male" : "Female"}`}</span>
        {showAppointmentTimeAndDate && <span className="d-block text-grey2 fs-sm">{`${formatDate(appointmentDate)} ${format4DigitTimeToAmOrPM(appointmentTime)}`}</span>}
      </div>
      {showView && (
        <Link className="bg-grey1 viewBtn" to={showViewHref}>
          View
        </Link>
      )}
    </Wrapper>
  );
};

export default PatientAppointmentRequestCard;

const Wrapper = styled.div`
  display: flex;
  gap: 1rem;
  border-radius: 16px !important;
  height: min-content;

  .content {
    display: flex;
  }
  .name__placeholder {
    margin: auto;
    height: 100%;
    width: 100%;
    text-align: center;
    vertical-align: middle;
    border-radius: 12px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 40px;
    font-weight: 500;
  }

  /* ${imageBaseUrl}/ */
  .appointment__item-img {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 80px;
    width: 80px;
    border-radius: 12px;
    padding: 4px;
    text-align: center;
    object-fit: cover;
  }
  .appointment__item-img img {
    text-align: center;
    object-fit: cover;
    height: 100%;
    width: 100%;
    border-radius: 12px;
  }
  .viewBtn {
    height: min-content;
    width: min-content;
    padding: 6px 16px;
    border-radius: 30px;
    align-self: center;
    margin-left: auto;
    margin-right: 0.5rem;
    font-weight: 500;
    font-size: 0.95rem;
    color: ${tuftsBlue};
    transition: all ease-in-out 0.3s;
    &:hover {
      background-color: #d6d6d6;
    }
  }
`;
